// extracted by mini-css-extract-plugin
module.exports = {"more-text":"more-text__more-text___OmEI_","more-text--text":"more-text__more-text--text___1xprQ","_plain":"more-text___plain___2e1T0"};